import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { drawerBodyInjectionKey as c } from "../../drawer/src/interface.js";
import { modalBodyInjectionKey as m } from "../../modal/src/interface.js";
import { popoverBodyInjectionKey as y } from "../../popover/src/interface.js";
import { renderArrow as w } from "../../popover/src/PopoverBody.js";
import { dropdownInjectionKey as h, dropdownMenuInjectionKey as v } from "./context.js";
import N from "./DropdownDivider.js";
import b from "./DropdownGroup.js";
import S from "./DropdownOption.js";
import K from "./DropdownRenderOption.js";
import { isSubmenuNode as a, isRenderNode as k, isDividerNode as D, isGroupNode as I } from "./utils.js";
import { XScrollbar as R } from "../../_internal/scrollbar/src/Scrollbar.js";
import { defineComponent as j, inject as x, provide as u, computed as f, h as t } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as B } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const E = j({
  name: "DropdownMenu",
  props: {
    scrollable: Boolean,
    showArrow: Boolean,
    arrowStyle: [String, Object],
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNodes: {
      type: Array,
      default: () => []
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  setup(i) {
    const {
      renderIconRef: o,
      childrenFieldRef: d
    } = x(h);
    u(v, {
      showIconRef: f(() => {
        const r = o.value;
        return i.tmNodes.some((e) => {
          var n;
          if (e.isGroup)
            return (n = e.children) === null || n === void 0 ? void 0 : n.some(({
              rawNode: p
            }) => r ? r(p) : p.icon);
          const {
            rawNode: s
          } = e;
          return r ? r(s) : s.icon;
        });
      }),
      hasSubmenuRef: f(() => {
        const {
          value: r
        } = d;
        return i.tmNodes.some((e) => {
          var n;
          if (e.isGroup)
            return (n = e.children) === null || n === void 0 ? void 0 : n.some(({
              rawNode: p
            }) => a(p, r));
          const {
            rawNode: s
          } = e;
          return a(s, r);
        });
      })
    });
    const l = B(null);
    return u(m, null), u(c, null), u(y, l), {
      bodyRef: l
    };
  },
  render() {
    const {
      parentKey: i,
      clsPrefix: o,
      scrollable: d
    } = this, l = this.tmNodes.map((r) => {
      const {
        rawNode: e
      } = r;
      return e.show === !1 ? null : k(e) ? t(K, {
        tmNode: r,
        key: r.key
      }) : D(e) ? t(N, {
        clsPrefix: o,
        key: r.key
      }) : I(e) ? t(b, {
        clsPrefix: o,
        tmNode: r,
        parentKey: i,
        key: r.key
      }) : t(S, {
        clsPrefix: o,
        tmNode: r,
        parentKey: i,
        key: r.key,
        props: e.props,
        scrollable: d
      });
    });
    return t("div", {
      class: [`${o}-dropdown-menu`, d && `${o}-dropdown-menu--scrollable`],
      ref: "bodyRef"
    }, d ? t(R, {
      contentClass: `${o}-dropdown-menu__content`
    }, {
      default: () => l
    }) : l, this.showArrow ? w({
      clsPrefix: o,
      arrowStyle: this.arrowStyle,
      arrowClass: void 0,
      arrowWrapperClass: void 0,
      arrowWrapperStyle: void 0
    }) : null);
  }
});
export {
  E as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dropdown/src/DropdownMenu.js
// module id = 951
// module chunks = 67